module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "VuexView"
  }, [_c('h2', {
    staticClass: "std"
  }, [_vm._v("Vuex State")]), _vm._v(" "), _c('div', {
    staticClass: "std"
  }, [_vm._v("{")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "indent2 std"
  }, [_c('span', {
    staticClass: "var"
  }, [_vm._v("name:")]), _vm._v(" "), _c('span', {
    staticClass: "lit"
  }, [_vm._v("'" + _vm._s(_vm.person.name) + "'")]), _c('span', {
    staticClass: "punc"
  }, [_vm._v(",")])]), _vm._v(" "), _c('div', {
    staticClass: "indent2 std"
  }, [_c('span', {
    staticClass: "var"
  }, [_vm._v("profession:")]), _vm._v(" "), _c('span', {
    staticClass: "lit"
  }, [_vm._v("'" + _vm._s(_vm.person.profession) + "'")])]), _vm._v(" "), _c('div', {
    staticClass: "indent1 std"
  }, [_vm._v("},")]), _vm._v(" "), _c('div', {
    staticClass: "indent1 std"
  }, [_c('span', {
    staticClass: "var"
  }, [_vm._v("apiError:")]), _vm._v(" "), _c('span', {
    staticClass: "lit"
  }, [_vm._v("'" + _vm._s(_vm.apiError) + "'")])]), _vm._v(" "), _c('div', {
    staticClass: "std"
  }, [_vm._v("}")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indent1 std"
  }, [_c('span', {
    staticClass: "var"
  }, [_vm._v("person")]), _vm._v(": {")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5243fe36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VuexView.vue
// module id = 108
// module chunks = 1